export default function AlertMsg({ type, msg }) {
  return (
    <div className={`text-xs ${type === "error" ? "text-red-600" : "text-primary"}`}>{msg}</div>
  );
}
